module.exports = __webpack_public_path__ + "static/media/C.ba96a15a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/alphabet/C.jpg
// module id = 71
// module chunks = 0